export default __webpack_public_path__ + "static/media/phone-mockup.6d9ef7e2.png";